import React, { useState, useEffect } from "react";

import { Form, Formik, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { isAfter, parse, isValid, format, isEqual } from "date-fns";

import {
  Flex,
  SimpleGrid,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Textarea,
  Divider,
  Text,
} from "@chakra-ui/react";

import {
  telefone as telMask,
  cpf as cpfMask,
  cep as cepMask,
  numeroEndereco,
  onlyNumbers,
  forNames,
} from "../../../../../utils/masks";

import DadosGeograficosService from "../../../../../../main/services/DadosGeograficosService";
import { CustomButton } from "../../../../../components/CustomButton";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { CustomSelectWField } from "../../../../../components/CustomSelectWField";
import { FocusError } from "../../../../../components/FocusError";
import CriancaService from "../../../../../../main/services/CriancaService";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import {
  Permission,
  referenciaFunc,
} from "../../../../../../helpers/Funcionalidades";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { isValidCPF } from "../../../../../utils/isValidCPF";

export const ComunitariaEditar = ({
  isOpen,
  onOpen,
  onClose,
  filiacoes,
  setFieldValue,
  selectedFiliacao,
  updateFromVisualizacao,
  dataNascimentoCA,
  isVisualizacao,
  secondOnClose,
  idCrianca,
  fetchReferenciaData,
  fetchDataGuarda,
  idRelacionamento,
  roleKeycloack,
  cpfBlocked,
  setCpfBlocked,
  dataReferencia,
  user,
  idPJ,
}) => {
  const [, setCPFExistChange] = useState(false);
  const [isVisual, setIsVisual] = useState(!!isVisualizacao);
  const [dataFutura, setDataFutura] = useState(false);
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const [estados, setEstados] = useState({ options: [], isLoading: false });
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [opcoesFiliacao, setOpcoesFiliacao] = useState({
    options: [],
    isLoading: false,
  });
  const { editarRefFamiliar, setEditarRefFamiliar } = useAppContext();
  const [initialValues, setInitialValues] = useState({
    cep: "",
    complemento: "",
    cpf: "",
    email: "",
    dataNascimento: "",
    id: "",
    idBairro: "",
    idEstado: "",
    idMunicipio: "",
    informacoesComplementares: "",
    idPessoaFisicaNovoVinculo: null,
    logradouro: "",
    nome: "",
    numeroIdentidade: "",
    numeroResidencia: "",
    pontoReferencia: "",
    telefone: "",
    possuiOutrosRelacionamentos: false,
    enderecoDisabled: false,
    idCriancaAcolhido: null,
  });
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [invalidCPF, setInvalidCPF] = useState(false);
  const [criancaCPFValid, setCriancaCPFValid] = useState(false);

  const backAlert = () => {
    if (editarRefFamiliar) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setEditarRefFamiliar(false);
        }
        setCpfBlocked(false);
      });
    } else {
      onClose();
      setCpfBlocked(false);
    }
  };

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    setMunicipios((prevState) => ({ ...prevState, isLoading: true }));
    if (estado) {
      DadosGeograficosService.pesquisarMunicipios(estado.id).then((res) => {
        setMunicipios({ options: res.data, isLoading: false });
      });
    } else {
      setMunicipios({ options: [], isLoading: false });
    }
  }, [estado]);

  useEffect(() => {
    setBairros((prevState) => ({ ...prevState, isLoading: true }));
    if (municipio) {
      DadosGeograficosService.pesquisarBairros(municipio.id).then((res) => {
        setBairros({ options: res.data, isLoading: false });
      });
    } else {
      setBairros({ options: [], isLoading: false });
    }
  }, [municipio]);

  const handleGetEstados = () => {
    setEstados({ ...estados, isLoading: true });
    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  };

  useEffect(() => {
    const {
      cep,
      complemento,
      cpf,
      dataNascimento,
      email,
      filiacaoCriancas,
      idBairro,
      bairro,
      idEstado,
      estado,
      idMunicipio,
      municipio,
      informacoesComplementares,
      logradouro,
      numeroIdentidade,
      numeroResidencia,
      pontoReferencia,

      telefone,
      tipoReferenciaFamiliar,
      possuiOutrosRelacionamentos,
      idCrianca: idCriancaAcolhido,
      possuiRelacionamentoPaiMae,
      ...resto
    } = selectedFiliacao;

    setInitialValues({
      idTipoReferencia: {
        label: tipoReferenciaFamiliar.descricao,
        value: tipoReferenciaFamiliar.id,
      },
      cep: cep ? cepMask(cep) : "",
      complemento: complemento ? complemento : "",
      cpf: cpf ? cpfMask(cpf) : "",
      dataNascimento: dataNascimento
        ? isValid(dataNascimento)
          ? format(new Date(dataNascimento), "dd/MM/yyyy")
          : dataNascimento
        : "",
      email: email ? email : "",
      idBairro: bairro ? bairro : idBairro ? idBairro : "",
      idEstado: estado ? estado : idEstado ? idEstado : "",
      idMunicipio: municipio ? municipio : idMunicipio ? idMunicipio : "",
      informacoesComplementares: informacoesComplementares
        ? informacoesComplementares
        : "",
      logradouro: logradouro ? logradouro : "",
      numeroIdentidade: numeroIdentidade ? numeroIdentidade : "",
      numeroResidencia: numeroResidencia ? numeroResidencia : "",
      pontoReferencia: pontoReferencia ? pontoReferencia : "",

      telefone: telefone ? telefone : "",
      enderecoDisabled:
        (possuiOutrosRelacionamentos && idCriancaAcolhido) ||
        possuiRelacionamentoPaiMae
          ? true
          : false,
      idCriancaAcolhido: idCriancaAcolhido ? idCriancaAcolhido : null,
      possuiOutrosRelacionamentos: possuiOutrosRelacionamentos
        ? possuiOutrosRelacionamentos
        : false,
      ...resto,
    });

    if (estado) {
      setEstado(estado);
    } else if (idEstado) {
      setEstado(idEstado);
    }
    if (municipio) {
      setMunicipio(municipio);
    } else if (idMunicipio) {
      setMunicipio(idMunicipio);
    }
    if (bairro) {
      setBairros(bairro);
    } else if (idBairro) {
      setBairros(idBairro);
    }
  }, [selectedFiliacao]);

  useEffect(() => {
    setOpcoesFiliacao("");
  }, []);

  const handleGetTipoReferencia = () => {
    setOpcoesFiliacao({ ...opcoesFiliacao, isLoading: true });
    CriancaService.getTipoReferencia().then((res) => {
      const formattedOptions = res.data.map((item) => ({
        label: item.descricao,
        value: item.id,
      }));
      setOpcoesFiliacao({
        options: formattedOptions,
        isLoading: false,
      });
    });
  };

  const handleGetCPF = async (cpf, props) => {
    if (cpf && cpf.length === 14 && !isVisual && initialValues.cpf !== cpf) {
      const resValid =
        await CriancaService.referenciaFamiliarComunitariaValidar(
          idCrianca,
          cpf?.replace(/[.-]|[.-](?=.)/g, "").trim()
        );
      if (
        resValid.data &&
        !resValid?.data?.pessoaFisicaReferenciaFamiliarComunitaria
          ?.tipoReferenciaFamiliar
      ) {
        Swal.fire({
          title: "Atenção!",
          text: `O CPF ${cpf} pertence a ${resValid?.data?.pessoaFisicaReferenciaFamiliarComunitaria?.nome}. Deseja utilizar os mesmos dados?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            setCPFExistChange(false);
            const { data } = resValid;
            const {
              pessoaFisicaReferenciaFamiliarComunitaria: {
                tipoReferenciaFamiliar,
                cep,
                complemento,
                email,
                dataNascimento,
                idPessoaFisica,
                bairro,
                estado,
                municipio,
                informacoesComplementares,
                logradouro,
                nome,
                numeroIdentidade,
                numeroResidencia,
                pontoReferencia,
                telefone,
                possuiOutrosRelacionamentos,
                idCrianca: idCriancaAcolhido,
                possuiRelacionamentoPaiMae,
              },
              idRelacionamento,
            } = data;

            setCpfBlocked(true);
            tipoReferenciaFamiliar?.id &&
              props.setFieldValue("idTipoReferencia", {
                label: tipoReferenciaFamiliar.descricao,
                id: tipoReferenciaFamiliar.id,
              });
            props.setFieldValue(
              "idPessoaFisicaNovoVinculo",
              idPessoaFisica ? idPessoaFisica : null
            );
            props.setFieldValue("cep", cep || "");
            props.setFieldValue("complemento", complemento || "");
            props.setFieldValue("email", email || "");
            props.setFieldValue(
              "dataNascimento",
              dataNascimento
                ? isValid(dataNascimento)
                  ? format(new Date(dataNascimento), "dd/MM/yyyy")
                  : dataNascimento
                : ""
            );
            props.setFieldValue("idPessoaFisica", idPessoaFisica || "");
            props.setFieldValue("idBairro", bairro || "");
            props.setFieldValue("idEstado", estado || "");
            props.setFieldValue("idMunicipio", municipio || "");
            props.setFieldValue(
              "informacoesComplementares",
              informacoesComplementares || ""
            );
            props.setFieldValue("logradouro", logradouro || "");
            props.setFieldValue("nome", nome || "");
            props.setFieldValue("numeroIdentidade", numeroIdentidade || "");
            props.setFieldValue("numeroResidencia", numeroResidencia || "");
            props.setFieldValue("pontoReferencia", pontoReferencia || "");
            props.setFieldValue("telefone", telefone || "");
            props.setFieldValue("idRelacionamento", idRelacionamento || "");
            props.setFieldValue(
              "enderecoDisabled",
              (possuiOutrosRelacionamentos && idCriancaAcolhido) ||
                possuiRelacionamentoPaiMae
                ? true
                : false
            );
          } else {
            onClose();
            setCpfBlocked(false);
          }
        });
      } else if (
        resValid.data &&
        resValid?.data?.pessoaFisicaReferenciaFamiliarComunitaria
          .tipoReferenciaFamiliar
      ) {
        setCPFExistChange(true);
        setCpfBlocked(false);
      } else {
        setCPFExistChange(false);
      }
    }
  };

  const clearEndereco = (props) => {
    props.setFieldValue("logradouro", "");
    props.setFieldValue("numeroResidencia", "");
    props.setFieldValue("complemento", "");
    props.setFieldValue("cep", "");
    props.setFieldValue("pontoReferencia", "");
  };

  const schema = Yup.object().shape(
    {
      idTipoReferencia: Yup.object()
        .nullable()
        .required("Este campo é obrigatório!"),
      cep: Yup.string(),
      complemento: Yup.string(),
      cpf: Yup.string()
        .test("unicidade", "", (value) => {
          if (
            criancaCPFValid &&
            value?.replace(/[.-]|[.-](?=.)/g, "").trim() !==
              selectedFiliacao?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim()
          ) {
            return false;
          } else {
            return true;
          }
        })
        .test("cpfValido", "", (value) => {
          if (!isValidCPF(value)) {
            return false;
          } else {
            return true;
          }
        }),
      email: Yup.string().trim().email("Email inválido!"),
      dataNascimento: Yup.string()
        .nullable()

        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .test(
          "dataNascimentoAfter",
          "A data informada não pode ser posterior ao nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        )
        .test(
          "dataNascimentoEqual",
          "A data informada não pode ser igual à data de nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isEqual(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        ),

      id: Yup.string(),
      idBairro: Yup.mixed().when("idMunicipio", {
        is: (municipio) =>
          municipio ? municipio.id === 3233 || municipio.id === 3215 : false,
        then: Yup.mixed().required("Este campo é obrigatório!").nullable(),
      }),
      idEstado: Yup.mixed(),
      idMunicipio: Yup.mixed(),
      informacoesComplementares: Yup.string(),
      logradouro: Yup.string(),
      nome: Yup.string()
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!")
        .when("cpf", {
          is: (cpf) => !!cpf,
          then: (schemaOuter) => {
            return schemaOuter.when("cpf", ([cpf], schema) => {
              return schema.test("unicidade", "Nome já cadastrado", (value) => {
                if (value) {
                  const found = filiacoes
                    .filter(
                      (filiacao) =>
                        filiacao.pessoaFisicaReferenciaFamiliarComunitaria
                          .idPessoaFisica !== selectedFiliacao.idPessoaFisica
                    )
                    .find((filiacao) => {
                      if (
                        filiacao.pessoaFisicaReferenciaFamiliarComunitaria.cpf
                      ) {
                        return (
                          filiacao.pessoaFisicaReferenciaFamiliarComunitaria.nome.toUpperCase() +
                            filiacao.pessoaFisicaReferenciaFamiliarComunitaria
                              .cpf ===
                          value.toUpperCase() + cpf
                        );
                      } else {
                        if (
                          !!filiacao.pessoaFisicaReferenciaFamiliarComunitaria
                            .nome &&
                          !!value
                        ) {
                          return (
                            filiacao.pessoaFisicaReferenciaFamiliarComunitaria.nome.toUpperCase() ===
                            value.toUpperCase() + cpf
                          );
                        } else {
                          return false;
                        }
                      }
                    });
                  if (!!found) {
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              });
            });
          },
        }),
      numeroIdentidade: Yup.string(),
      numeroResidencia: Yup.number(),
      pontoReferencia: Yup.string(),
      telefone: Yup.string()
        .min(14, "Telefone inválido!")
        .max(15, "Telefone inválido!"),
    },
    [
      ["cpf", "nome"],
      ["nome", "cpf"],
    ]
  );

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { dataNascimento, cpf } = values;
        const currentDate = new Date();

        if (dataNascimento) {
          const movementDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
          } else {
            setDataFutura(false);
          }
        }

        if (cpf) {
          if (isValidCPF(cpf)) {
            setInvalidCPF(true);
            setFieldError("cpf", "");
          } else {
            setInvalidCPF(false);
          }
        } else {
          setInvalidCPF(false);
        }
      };

      validateDate();
    }, [values, values.dataNascimento, setFieldError]);

    return null;
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        idTipoReferencia,
        nome,
        dataNascimento,
        cpf,
        numeroIdentidade,
        email,
        informacoesComplementares,
        idEstado,
        idMunicipio,
        idBairro,
        logradouro,
        complemento,
        pontoReferencia,
        id,
        local,
        idPessoaFisica,
        idPessoaFisicaNovoVinculo,
        ...resto
      } = values;

      const valuesToSend = {
        ...resto,
        idTipoReferencia: idTipoReferencia ? idTipoReferencia.value : null,
        nome: nome ? nome.trim() : "",
        dataNascimento: dataNascimento
          ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        cpf: cpf ? cpf.trim() : "",
        numeroIdentidade: numeroIdentidade ? numeroIdentidade.trim() : "",
        email: email ? email.trim() : "",
        informacoesComplementares: informacoesComplementares
          ? informacoesComplementares.trim()
          : "",
        idPessoaFisica: idPessoaFisica ? idPessoaFisica : 0,
        idPessoaFisicaNovoVinculo: idPessoaFisicaNovoVinculo
          ? idPessoaFisicaNovoVinculo
          : null,
        idEstado: idEstado ? idEstado.id : "",
        idMunicipio: idMunicipio ? idMunicipio.id : "",
        idBairro: idBairro ? idBairro.id : "",
        logradouro: logradouro ? logradouro.trim() : "",
        complemento: complemento ? complemento.trim() : "",
        pontoReferencia: pontoReferencia ? pontoReferencia.trim() : "",
      };

      const valuesToValidate = { ...valuesToSend };
      //delete valuesToValidate.idPessoaFisica;

      CriancaService.validarReferencia(idCrianca, [valuesToValidate])
        .then((res) => {
          CriancaService.putReferencia(
            idCrianca,
            valuesToSend,
            idRelacionamento
          )
            .then((res) => {
              fetchReferenciaData();
              fetchDataGuarda && fetchDataGuarda();
              Swal.fire({
                title: "Sucesso!",
                text: "Registro Alterado com sucesso!",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              }).then((result) => {
                if (result.isConfirmed) {
                  onClose();
                }
              });
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                const errors = JSON.parse(error.response.data.message);
                for (let key in errors) {
                  actions.setFieldError(
                    key.toString().slice(key.toString().indexOf(".") + 1),
                    errors[key]
                  );
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(
                      erro.field
                        .toString()
                        .slice(erro.field.toString().indexOf(".") + 1),
                      erro.message
                    );
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
        });

      actions.setSubmitting(false);
    }, 200);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {isVisual
              ? "Visualizar Referência Familiar e Comunitária".toUpperCase()
              : "Editar Referência Familiar e Comunitária".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form style={{ width: "100%", paddingBottom: "5px" }}>
                  {setEditarRefFamiliar(
                    hasFormChanged(initialValues, props.values)
                  )}
                  <FocusError />
                  <FocusErrorData />
                  <Grid templateColumns="repeat(4, 1fr)" gap="15px" w="100%">
                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomSelectWField
                        fieldName="idTipoReferencia"
                        label="Tipo de Referência*"
                        placeholder="Selecione o tipo"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        isLoading={opcoesFiliacao.isLoading}
                        options={opcoesFiliacao.options}
                        onChange={(value) => {
                          props.setFieldValue("idTipoReferencia", value);
                        }}
                        onFocus={handleGetTipoReferencia}
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 2 }}>
                      <CustomInputWField
                        fieldName="nome"
                        label="Nome*"
                        maxLength={145}
                        placeholder="Informe o Nome"
                        onChange={(e) =>
                          props.setFieldValue("nome", forNames(e.target.value))
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <VStack alignItems="flex-start">
                        <CustomDatepickerWField
                          fieldName="dataNascimento"
                          label="Data de Nascimento"
                          placeholder="DD/MM/AAAA"
                          isDisabled={isVisual}
                          maxDate={new Date()}
                        />
                        {dataFutura && props.values.dataNascimento && (
                          <Text
                            mt="8px"
                            color="#E53E3E"
                            fontSize="sm"
                            lineHeight={"normal"}
                          >
                            A data informada não pode ser uma data futura!
                          </Text>
                        )}
                      </VStack>
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="cpf"
                        label="CPF"
                        placeholder="000.000.000-00"
                        maxLength={14}
                        onChange={(e) => {
                          props.setFieldValue("cpf", cpfMask(e.target.value));
                          if (isValidCPF(cpfMask(e.target.value))) {
                            if (
                              e.target.value
                                ?.replace(/[.-]|[.-](?=.)/g, "")
                                .trim() !==
                              selectedFiliacao?.cpf
                                ?.replace(/[.-]|[.-](?=.)/g, "")
                                .trim()
                            ) {
                              CriancaService.validaCPFCrianca(
                                idCrianca,
                                cpfMask(e.target.value)
                              )
                                .then(() => {
                                  setCriancaCPFValid(false);
                                  handleGetCPF(cpfMask(e.target.value), props);
                                })
                                .catch((error) => {
                                  console.log(error);
                                  setCriancaCPFValid(true);
                                });
                            } else {
                              setCriancaCPFValid(false);
                            }
                          }
                        }}
                        isDisabled={
                          isVisual ||
                          cpfBlocked ||
                          (props.values.cpf &&
                            (props.values.possuiOutrosRelacionamentos ||
                              props.values.enderecoDisabled))
                        }
                        setIsFocused={setIsFocused}
                        setIsBlur={
                          props?.values?.cpf?.replace(/[^\d]+/g, "").length ===
                            11 && setIsBlur
                        }
                      />

                      {props.values.cpf &&
                        !isFocused &&
                        !invalidCPF &&
                        !isBlur && (
                          <Text
                            color="red"
                            opacity={0.8}
                            mt={2}
                            fontSize="12px"
                          >
                            Informar um CPF válido
                          </Text>
                        )}
                      {props.values.cpf &&
                        !isFocused &&
                        criancaCPFValid &&
                        invalidCPF &&
                        !isBlur && (
                          <Text
                            color="red"
                            opacity={0.8}
                            mt={2}
                            fontSize="12px"
                          >
                            CPF já cadastrado nessa ficha.
                          </Text>
                        )}
                      {/* {cpfExistChange &&
                        props.values.cpf &&
                        props.values.cpf.length === 14 &&
                        !props.errors.cpf && (
                          <Text
                            color="red"
                            opacity={0.8}
                            fontSize="12px"
                            mt={2}
                          >
                            Já existe uma referência familiar comunitária com
                            CPF: {props.values.cpf}
                          </Text>
                        )} */}
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="numeroIdentidade"
                        label="Identidade"
                        placeholder="Informe a Identidade"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroIdentidade",
                            onlyNumbers(e.target.value)
                          )
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="telefone"
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "telefone",
                            telMask(e.target.value)
                          )
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="email"
                        label="E-mail"
                        maxLength={80}
                        placeholder="Informe o e-mail"
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={4}>
                      <Field name="informacoesComplementares">
                        {({ field, form }) => (
                          <Flex flexDir="column" position="relative">
                            <FormControl
                              isInvalid={
                                form.errors.informacoesComplementares &&
                                form.touched.informacoesComplementares
                              }
                            >
                              <FormLabel
                                color="#5F6377"
                                fontWeight="500"
                                fontSize="14px"
                                lineHeight="19.6px"
                                htmlFor="informacoesComplementares"
                              >
                                Informações Complementares
                              </FormLabel>
                              <Textarea
                                {...field}
                                name="informacoesComplementares"
                                id="informacoesComplementares"
                                backgroundColor="#fff"
                                autoComplete="off"
                                border="1px solid #D7D8DE"
                                onFocus={() => setIsTextareaFocused(true)}
                                onBlur={() => setIsTextareaFocused(false)}
                                placeholder="Informe as Informações Complementares"
                                maxLength={255}
                                isDisabled={isVisual}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value.length <= 255) {
                                    form.setFieldValue(
                                      "informacoesComplementares",
                                      value
                                    );
                                  }
                                }}
                              />
                              <Text
                                zIndex={isTextareaFocused ? 1 : 0}
                                fontSize="sm"
                                position="absolute"
                                bottom="5px"
                                right="15px"
                                color={
                                  field.value.length === 255 ? "red" : "gray"
                                }
                              >
                                {field.value.length}/255
                              </Text>
                              <FormErrorMessage>
                                {form.errors.informacoesComplementares}
                              </FormErrorMessage>
                            </FormControl>
                          </Flex>
                        )}
                      </Field>
                    </GridItem>
                  </Grid>

                  <Divider mt="15px" />
                  <Text
                    color="#5F6377"
                    fontWeight={500}
                    fontSize="14px"
                    lineHeight="19.6px"
                    mt="15px"
                  >
                    Endereço
                  </Text>

                  <Grid
                    templateColumns="repeat(9, 1fr)"
                    gap="15px"
                    mt="15px"
                    w="100%"
                  >
                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idEstado"
                        label="Estado"
                        placeholder="Selecione o Estado"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={estados.isLoading}
                        options={estados.options}
                        onChange={(value) => {
                          if (value && props.values.idEstado) {
                            if (value.nome !== props.values.idEstado.nome) {
                              props.setFieldValue("idMunicipio", "");
                              props.setFieldValue("idBairro", "");
                            }
                          } else {
                            props.setFieldValue("idMunicipio", "");
                            props.setFieldValue("idBairro", "");
                          }
                          setEstado(value);
                          setMunicipio(false);
                          props.setFieldValue("idEstado", value);
                          clearEndereco(props);
                        }}
                        onFocus={
                          estados.options.length === 0 ? handleGetEstados : null
                        }
                        isDisabled={isVisual || props.values.enderecoDisabled}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idMunicipio"
                        label="Cidade"
                        placeholder="Selecione a Cidade"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={municipios.isLoading}
                        options={municipios.options}
                        onChange={(value) => {
                          setMunicipio(value);
                          props.setFieldValue("idMunicipio", value);
                          props.setFieldValue("idBairro", "");
                          clearEndereco(props);
                        }}
                        isDisabled={isVisual || props.values.enderecoDisabled}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idBairro"
                        label={`Bairro${
                          props?.values?.idMunicipio?.id === 3233 ||
                          props?.values?.idMunicipio?.id === 3215
                            ? "*"
                            : ""
                        }`}
                        placeholder="Selecione o Bairro"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={bairros.isLoading}
                        options={bairros.options}
                        onChange={(value) => {
                          props.setFieldValue("idBairro", value);
                          !value && clearEndereco(props);
                        }}
                        isDisabled={isVisual || props.values.enderecoDisabled}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="logradouro"
                        label="Logradouro"
                        maxLength={100}
                        placeholder="Informe o Logradouro"
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro ||
                          props.values.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="numeroResidencia"
                        label="Número"
                        placeholder="Informe o Número"
                        maxLength={14}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroResidencia",
                            numeroEndereco(e.target.value)
                          )
                        }
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro ||
                          props.values.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="complemento"
                        label="Complemento"
                        maxLength={120}
                        placeholder="Informe o Complemento"
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro ||
                          props.values.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="cep"
                        label="CEP"
                        placeholder="Informe o CEP"
                        maxLength={9}
                        onChange={(e) =>
                          props.setFieldValue("cep", cepMask(e.target.value))
                        }
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro ||
                          props.values.enderecoDisabled
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 9 }}>
                      <CustomInputWField
                        fieldName="pontoReferencia"
                        label="Ponto de Referência"
                        maxLength={2000}
                        placeholder="Informe o Ponto de Referência"
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro ||
                          props.values.enderecoDisabled
                        }
                      />
                    </GridItem>
                  </Grid>
                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={2}
                      spacing="15px"
                      w={{ base: "100%", lg: "40%" }}
                    >
                      {isVisual ? (
                        <CustomButton onClick={onClose} label="Voltar" />
                      ) : (
                        <CustomButton onClick={backAlert} label="Cancelar" />
                      )}
                      {isVisual ? (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={referenciaFunc.referenciaAlterar}
                          user={user}
                          id={idPJ}
                          visualizar={true}
                        >
                          <CustomButton
                            onClick={(e) => {
                              e.preventDefault();
                              setIsVisual(false);
                            }}
                            label="Editar"
                          />
                        </Permission>
                      ) : (
                        <CustomButton
                          type="submit"
                          translate="no"
                          isLoading={props.isSubmitting}
                          label="Salvar"
                        />
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
